/* ===========================================================
   1) Julisteiden mitoitus: sama pinta-ala kaikille
   2) Ylavalikon paakohdat klikattaviksi + "Kaikki ..." linkki
   3) Genre-ruudukko kokoelmasivun ylaosaan
   Toimii kaikilla kielilla (/, /en/, /sv/).
   Tarvitsee window.KJ_MENU -taulukon (tulostetaan Liquidilla).
   =========================================================== */
(function () {

  /* ---------- 1. Julisteiden mitoitus ---------- */
  function sizeOne(card) {
    if (!card) return;
    var img = card.querySelector('img');
    if (!img) return;
    var w = parseFloat(img.getAttribute('width')) || img.naturalWidth;
    var h = parseFloat(img.getAttribute('height')) || img.naturalHeight;
    if (!w || !h) {
      if (!img.dataset.posterBound) {
        img.dataset.posterBound = '1';
        img.addEventListener('load', function () { sizeOne(card); }, { once: true });
      }
      return;
    }
    var ar = w / h;
    card.style.setProperty('--ar-w', Math.sqrt(ar).toFixed(4));
    card.style.setProperty('--ar-h', Math.sqrt(1 / ar).toFixed(4));
  }

  function sizeAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll('.product-card-wrapper');
    for (var i = 0; i < cards.length; i++) sizeOne(cards[i]);
    if (root && root.matches && root.matches('.product-card-wrapper')) sizeOne(root);
  }

  /* ---------- Kieliprefiksin kasittely ----------
     Shopify tulostaa valikon osoitteet kielikohtaisina
     (esim. /sv/collections/elokuvat). Vertailu tehdaan aina
     ilman prefiksia, ja linkkeihin lisataan nykyinen prefiksi. */
  var LOCALE_RE = /^\/(en|sv)(?=\/|$)/;

  function stripLocale(p) {
    return (p || '').replace(LOCALE_RE, '') || '/';
  }

  function pathOf(u) {
    try { return new URL(u, location.origin).pathname; }
    catch (e) { return u; }
  }

  function key(u) {
    var p = stripLocale(pathOf(u));
    return p.length > 1 ? p.replace(/\/$/, '') : p;
  }

  function localePrefix() {
    var m = location.pathname.match(LOCALE_RE);
    return m ? m[0] : '';
  }

  function withLocale(u) {
    var bare = stripLocale(pathOf(u));
    var p = localePrefix();
    return p ? p + bare : bare;
  }

  function allLabel(title) {
    var p = localePrefix();
    if (p === '/en') return 'All ' + title.toLowerCase();
    if (p === '/sv') return 'Alla ' + title.toLowerCase();
    return 'Kaikki ' + title.toLowerCase();
  }

  /* ---------- 2. Valikon paakohdat ----------
     Summaryn ensimmainen <span> on mobiilivalikossa tyhja,
     siksi otsikko luetaan koko summaryn tekstisisallosta. */
  function enhanceMenu() {
    if (!window.KJ_MENU || !KJ_MENU.length) return;
    var groups = document.querySelectorAll('.header__inline-menu details, .menu-drawer details');
    for (var i = 0; i < groups.length; i++) {
      (function (d) {
        if (d.dataset.kjDone) return;
        var sum = d.querySelector('summary');
        if (!sum) return;
        var label = (sum.textContent || '').replace(/\s+/g, ' ').trim();
        if (!label) return;
        var entry = null;
        for (var k = 0; k < KJ_MENU.length; k++) {
          if (KJ_MENU[k].title.replace(/\s+/g, ' ').trim() === label) { entry = KJ_MENU[k]; break; }
        }
        if (!entry) return;
        d.dataset.kjDone = '1';
        var target = withLocale(entry.url);

        var list = d.querySelector('ul');
        if (list && !list.querySelector('.kj-all-link')) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = target;
          a.textContent = allLabel(entry.title);
          a.className = d.closest('.menu-drawer')
            ? 'menu-drawer__menu-item link link--text list-menu__item focus-inset kj-all-link'
            : 'header__menu-item list-menu__item link link--text focus-inset kj-all-link';
          a.style.fontWeight = '600';
          li.appendChild(a);
          list.insertBefore(li, list.firstChild);
        }

        if (d.closest('.header__inline-menu')) {
          sum.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = target;
          });
          d.addEventListener('mouseenter', function () { d.setAttribute('open', ''); });
          d.addEventListener('mouseleave', function () { d.removeAttribute('open'); });
        }
      })(groups[i]);
    }
  }

  /* ---------- 3. Genre-ruudukko ---------- */
  function buildGenres() {
    if (!window.KJ_MENU || !KJ_MENU.length) return;
    if (document.querySelector('.kj-genres')) return;
    var here = key(location.pathname);
    var entry = null;
    for (var i = 0; i < KJ_MENU.length; i++) {
      var m = KJ_MENU[i];
      if (key(m.url) === here) { entry = m; break; }
      for (var j = 0; j < m.children.length; j++) {
        if (key(m.children[j].url) === here) { entry = m; break; }
      }
      if (entry) break;
    }
    if (!entry) return;

    var host = document.querySelector('.collection');
    if (!host) return;

    var ul = document.createElement('ul');
    ul.className = 'kj-genres';
    var all = [{ title: allLabel(entry.title), url: entry.url }].concat(entry.children);
    for (var n = 0; n < all.length; n++) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = withLocale(all[n].url);
      a.textContent = all[n].title;
      if (key(all[n].url) === here && n > 0) a.className = 'kj-current';
      if (n === 0 && key(entry.url) === here) a.className = 'kj-current';
      li.appendChild(a);
      ul.appendChild(li);
    }

    var anchor = host.querySelector('.facets-container, .collection__title, .product-grid-container');
    if (anchor) { anchor.parentNode.insertBefore(ul, anchor); }
    else { host.insertBefore(ul, host.firstChild); }
  }

  function runAll(root) {
    sizeAll(root);
    enhanceMenu();
    buildGenres();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { runAll(); });
  } else {
    runAll();
  }
  window.addEventListener('load', function () { runAll(); });
  document.addEventListener('shopify:section:load', function (e) { runAll(e.target); });

  if (window.MutationObserver) {
    var start = function () {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          for (var j = 0; j < muts[i].addedNodes.length; j++) {
            if (muts[i].addedNodes[j].nodeType === 1) sizeAll(muts[i].addedNodes[j]);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
  }
})();
